import { IconWrapper } from '../runtime';
export default IconWrapper('poster_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#6964FA"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#5651E6"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#817CFF"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#6964FA"
    }
  }), h("path", {
    "attrs": {
      "d": "M11.2972 12.8435C11.8408 12.8435 12.2816 12.4028 12.2816 11.8591C12.2816 11.3155 11.8408 10.8748 11.2972 10.8748C10.7535 10.8748 10.3128 11.3155 10.3128 11.8591C10.3128 12.4028 10.7535 12.8435 11.2972 12.8435Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10.2175 2.53125L2.9209 6.87735L4.74004 10.0917L2.93035 11.1345L3.81973 12.6779L4.93583 12.0347C4.98568 12.694 5.1737 13.3175 5.50328 13.8712C6.21353 15.0645 7.49787 15.7921 9.09487 15.8772C10.9319 15.9751 12.4794 15.5747 13.5965 14.8295C14.7139 14.0842 15.4215 12.9679 15.4215 11.7185C15.4215 10.9915 15.2462 10.3107 14.8555 9.75103C14.5819 9.35905 14.2232 9.05644 13.8035 8.84592C13.6959 8.29076 13.4475 7.76785 13.0749 7.34437L14.8822 6.30285L13.9928 4.75953L12.1866 5.80039L10.2175 2.53125ZM10.643 6.68993L9.60619 4.96863L5.32918 7.51618L6.28341 9.20225L10.643 6.68993ZM7.03391 12.9601C6.7378 12.4627 6.61175 11.7809 6.77599 10.9742L11.4452 8.28352C11.8273 8.50587 12.083 8.94497 12.083 9.47879V10.1592L12.7396 10.3381C13.0556 10.4242 13.2607 10.5782 13.3949 10.7706C13.5342 10.97 13.6402 11.2736 13.6402 11.7185C13.6402 12.2504 13.3411 12.8587 12.608 13.3477C11.8747 13.8369 10.7279 14.1805 9.18967 14.0985C8.09758 14.0403 7.39756 13.5711 7.03391 12.9601Z",
      "fill": "white"
    }
  })]);
});